import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { contentfulViews, components } from '@glowforge/ui-common';
import Helmet from 'react-helmet';
import MediaCard from '../landing/media-card';

import './customer-gallery.less';

const { ButtonLink } = contentfulViews;
const { PageableGridList } = components;

const TopicCard = ({ href, contentfulImage, ctaText }) => (
  <div className='topic'>
    <a className='topicLink' href={href}>
      <MediaCard image={contentfulImage}>
        <div className='ctaText'>
          <span>{ctaText}</span>
        </div>
      </MediaCard>
    </a>
  </div>
);

TopicCard.propTypes = {
  href: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  contentfulImage: PropTypes.shape({}).isRequired,
};

const topicCards = (discoverCards) => {
  const listItems = discoverCards.map(cardModel => (
    <TopicCard
      key={_.get(cardModel, 'fields.callToActionButton.fields.url')}
      href={_.get(cardModel, 'fields.callToActionButton.fields.url')}
      contentfulImage={_.get(cardModel, 'fields.images[0]')}
      ctaText={_.get(cardModel, 'fields.callToActionButton.fields.text')} />
  ));
  // TODO: set swipe to see more text to empty as a default
  return <PageableGridList listItems={listItems} swipeToShowMoreText='' />;
};

const GalleryPage = (props) => {
  const yotpoScript = '(function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="https://staticw2.yotpo.com/LkFRBxdJYaHaqTIARYEaUjsuVKBlAoRMqOMvoS81/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();';
  const yotpoGallery = props.features.YOTPO_UPDATED_GALLERY ?
    (
      <div
        className='yotpo yotpo-pictures-widget'
        data-gallery-id='5c4229d2ec3372782507b83c' />
    ) : (
      <div
        className='yotpo yotpo-pictures-widget'
        data-album-id='5b64c808905ce6000d458f61'
        data-layout='full_page'
        data-layout-scroll='0'
        data-spacing='1'
        data-title='0'
        data-hover-color='#ffffff'
        data-hover-opacity='0.8'
        data-hover-icon='true'
        data-cta-text={props.lightboxCTA}
        data-cta-color='#007b88'
        data-upload-button='1'
        data-upload-button-text={props.uploadText}
        data-upload-button-background-color='#f6fbfd'
        data-upload-button-text-color='#007b88'
        data-upload-button-font-family='Open Sans' />
    );

  const discoverSection = (props.features.LAUNCH_DISCOVER && props.discoverCards) ?
    (
      <div className='discoverSection'>
        <div className='header'>
          <h1 className='h1'>{props.titleTextDiscover}</h1>
          <h2 className='subTitle'>{props.subTitleTextDiscover}</h2>
        </div>
        {topicCards(props.discoverCards)}
      </div>
    )
    : null;

  return (
    <div className='CustomerGallery contentPage'>
      <Helmet>
        <script type='text/javascript'>{yotpoScript}</script>
      </Helmet>
      {discoverSection}
      <div className='header'>
        <h1 className='h1'>{props.titleText}</h1>
        <h2 className='subTitle'>{props.subTitleText}</h2>
      </div>
      {yotpoGallery}
      <ButtonLink className='cta' {...props.customerGalleryCTA} />
    </div>
  );
};

GalleryPage.propTypes = {
  titleText: PropTypes.string.isRequired,
  subTitleText: PropTypes.string,
  titleTextDiscover: PropTypes.string.isRequired,
  subTitleTextDiscover: PropTypes.string,
  lightboxCTA: PropTypes.string.isRequired,
  uploadText: PropTypes.string.isRequired,
  customerGalleryCTA: ButtonLink.propTypes.isRequired,
  discoverCards: PropTypes.arrayOf(PropTypes.shape({})),
  features: PropTypes.shape({
    YOTPO_UPDATED_GALLERY: PropTypes.bool,
    LAUNCH_DISCOVER: PropTypes.bool,
  }),
};

GalleryPage.defaultProps = {
  subTitleText: null,
  subTitleTextDiscover: null,
  discoverCards: null,
  features: {},
};

export default GalleryPage;



// WEBPACK FOOTER //
// ./app/components/product/customer-gallery.jsx